const profiles = {
  school: {
    categoryLabel: 'School',
    people: 'Students', person: 'Student', personId: 'Student ID',
    groups: 'Classes', group: 'Class',
    areas: 'Subjects', area: 'Subject',
    schedules: 'Timetable', schedule: 'Period',
    leader: 'Teacher', leaders: 'Teachers',
    linkedPeople: 'Children', linkedPerson: 'Child',
    operationsDescription: 'RFID attendance and school operations',
    roleLabels: { admin: 'Administrator', manager: 'Principal', teacher: 'Teacher', student: 'Student', employee: 'Staff', parent: 'Parent' },
  },
  college: {
    categoryLabel: 'College',
    people: 'Students', person: 'Student', personId: 'Student ID',
    groups: 'Batches', group: 'Batch',
    areas: 'Courses', area: 'Course',
    schedules: 'Timetable', schedule: 'Period',
    leader: 'Faculty', leaders: 'Faculty',
    linkedPeople: 'Students', linkedPerson: 'Student',
    operationsDescription: 'RFID attendance and college operations',
    roleLabels: { admin: 'Administrator', manager: 'Dean', teacher: 'Faculty', student: 'Student', employee: 'Staff', parent: 'Guardian' },
  },
  office: {
    categoryLabel: 'Office',
    people: 'Employees', person: 'Employee', personId: 'Employee ID',
    groups: 'Teams', group: 'Team',
    areas: 'Work Areas', area: 'Work Area',
    schedules: 'Work Schedules', schedule: 'Work Schedule',
    leader: 'Supervisor', leaders: 'Supervisors',
    linkedPeople: 'Linked People', linkedPerson: 'Linked Person',
    operationsDescription: 'RFID attendance and office operations',
    roleLabels: { admin: 'Administrator', manager: 'Manager', teacher: 'Supervisor', student: 'Employee', employee: 'Staff', parent: 'Viewer' },
  },
};

export const normalizeEntityCategory = (category) => (
  Object.prototype.hasOwnProperty.call(profiles, category) ? category : 'office'
);

export const getTerminology = (category) => profiles[normalizeEntityCategory(category)];

export const getEntityRoleLabel = (role, category, fallbackName) => {
  const label = getTerminology(category).roleLabels[role];
  return label || fallbackName || String(role || 'User').replace(/_/g, ' ');
};

const sentenceCase = (value) => {
  const text = String(value || '').replace(/[._]/g, ' ').trim();
  return text ? `${text.charAt(0).toUpperCase()}${text.slice(1)}` : '';
};

export const getPermissionLabel = (permission, terminology) => {
  const categoryLabels = {
    'sections.view': `View ${terminology.groups}`,
    'sections.manage': `Manage ${terminology.groups}`,
    'subjects.view': `View ${terminology.areas}`,
    'subjects.manage': `Manage ${terminology.areas}`,
    'timetable.view': `View ${terminology.schedules}`,
    'timetable.manage': `Manage ${terminology.schedules}`,
    'parent.view': `View ${terminology.linkedPeople}`,
  };
  return categoryLabels[permission?.code] || permission?.name || sentenceCase(permission?.code);
};

export const getPermissionCategoryLabel = (category, terminology) => {
  const categoryLabels = {
    sections: terminology.groups,
    subjects: terminology.areas,
    timetable: terminology.schedules,
    parent: terminology.linkedPeople,
  };
  return categoryLabels[category] || sentenceCase(category || 'general');
};

export const entityCategories = Object.keys(profiles);
